import React from "react";

import { throttle } from "lodash";

function useThrottledValue<T>(value: T, wait: number) {
	const [memoValue, setMemoValue] = React.useState(value);
	const throttledSetMemoValue = React.useMemo(
		() => throttle(setMemoValue, wait, { trailing: true }),
		[setMemoValue, wait],
	);
	React.useEffect(() => {
		throttledSetMemoValue(value);
	}, [value, throttledSetMemoValue]);
	return memoValue;
}

export default useThrottledValue;
